<template>
<div></div>
</template>

<script>
import * as THREE from 'three'
/* eslint-disable */
import 'imports-loader?THREE=three!three/examples/js/loaders/OBJLoader.js'

import 'imports-loader?THREE=three!three/examples/js/postprocessing/EffectComposer.js'
import 'imports-loader?THREE=three!three/examples/js/postprocessing/RenderPass.js'
import 'imports-loader?THREE=three!three/examples/js/postprocessing/MaskPass.js'
import 'imports-loader?THREE=three!three/examples/js/postprocessing/ShaderPass.js'
import 'imports-loader?THREE=three!three/examples/js/shaders/CopyShader.js'
import 'imports-loader?THREE=three!three/examples/js/shaders/FXAAShader.js'
import 'imports-loader?THREE=three!three/examples/js/shaders/ConvolutionShader.js'
import 'imports-loader?THREE=three!three/examples/js/shaders/LuminosityHighPassShader.js'
import 'imports-loader?THREE=three!three/examples/js/postprocessing/UnrealBloomPass.js'

import * as Remixer from '@/components/Pages/KeyRemixer/remixer.js'

/* eslint-enable */

export default {
  data () {
    return {
      RS: Remixer.state
    }
  },
  computed: {
    bloomJSON () {
      return JSON.stringify(this.RS.bloom)
    }
  },
  props: {
    bg: {},
    camera: {},
    renderer: {},
    useFresnel: {},
    scene: {},
    texture: {},
    viewBG: {
      default: false
    }
  },
  watch: {
    bloomJSON () {
      if (this.remixBloom) {
        console.log('test')
        this.remixBloom(this.RS.bloom)
      }
    },
    texture () {
      if (this.texture && this.remixFn) {
        this.remixFn({ texture: this.texture })
      }
    }
  },
  mounted () {
    // let arr = [
    //   require('./img/star3/px.png'),
    //   require('./img/star3/nx.png'),
    //   require('./img/star3/py.png'),

    //   require('./img/star3/ny.png'),
    //   require('./img/star3/pz.png'),
    //   require('./img/star3/nz.png')
    // ]

    // if (this.bg) {
    //   arr = [
    //     this.bg,
    //     this.bg,
    //     this.bg,

    //     this.bg,
    //     this.bg,
    //     this.bg
    //   ]
    // }

    /* eslint-disable */
    var floor, floor1, floor2, floor3, floor15, floor25;
    var box3dGroup = new THREE.Object3D()
    // box3dGroup.rotation.z = Math.PI * -0.23

    let cfg = {
      now: 'b2',
      b1: {
        f1: require('./cdp/amy3.jpg'),
        f2: require('./cdp/amy2.jpg'),
        f3: require('./cdp/sky-edit.jpg'),
        f4: require('./cdp/sky-edit.jpg'),
        f5: require('./cdp/sky-edit.jpg'),
        f6: require('./cdp/sky-edit.jpg'),
        f7: require('./cdp/amy3.jpg')
      },
      b2: {
        f1: require('./cdp2/waterdudv.jpg'),
        f2: require('./cdp/amy2.jpg'),
        f3: require('./cdp/amy2.jpg'),
        f4: require('./cdp/waterdudv2.jpg'),
        f5: require('./cdp/sky-2.jpg'),
        f6: require('./cdp/sky-2.jpg'),
        f7: require('./cdp/amy3.jpg')
      },
      b3: {
        f1: require('./cdp2/amy6.jpg'),
        f2: require('./cdp/sky-2.jpg'),
        f3: require('./cdp2/amy6.jpg'),
        f4: require('./cdp2/waterdudv.jpg'),
        f5: require('./cdp2/waterdudv.jpg'),
        f6: require('./cdp2/amy6.jpg'),
        f7: require('./cdp/waterdudv.jpg')
      },
      b4: {
        f1: require('./cdp3/amy6.jpg'),
        f2: require('./cdp3/sky-r1.jpg'),
        f3: require('./cdp3/amy6.jpg'),
        f4: require('./cdp3/waterdudv.jpg'),
        f5: require('./cdp3/waterdudv.jpg'),
        f6: require('./cdp3/amy6.jpg'),
        f7: require('./cdp3/waterdudv.jpg')
      },
      b5: {
        f1: require('./cdp3/amy6.jpg'),
        f2: require('./cdp3/sky-r1.jpg'),
        f3: require('./cdp3/amy6.jpg'),
        f4: require('./cdp3/waterdudv.jpg'),
        f5: require('./cdp3/waterdudv.jpg'),
        f6: require('./cdp3/amy6.jpg'),
        f7: require('./cdp3/waterdudv.jpg')
      }
    }

    // FLOOR
    // var floorTexture = new THREE.ImageUtils.loadTexture( require('./cdp/white.jpg') );
    // var floorTexture = new THREE.ImageUtils.loadTexture( require('./cdp2/waterdudv.jpg') );
    // var floorTexture = new THREE.ImageUtils.loadTexture( require('./cdp/amy3.jpg') );
    // var floorTexture = new THREE.ImageUtils.loadTexture( require('./cdp/amy3.jpg') );
    var floorTexture = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f1 );
    floorTexture.wrapS = floorTexture.wrapT = THREE.RepeatWrapping;
    floorTexture.repeat.set( 1, 1 );
    var floorMaterial = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture, side:THREE.BackSide } );
    var floorGeometry = new THREE.PlaneGeometry(1000, 1000);
    floor = new THREE.Mesh(floorGeometry, floorMaterial);
    floor.position.y = -300;
    floor.rotation.x = Math.PI / 2;
    floor.visible = false
    box3dGroup.add(floor);

    // Back
    // var floorTexture1 = new THREE.ImageUtils.loadTexture( require('./cdp/amy2.jpg') );
    // var floorTexture1 = new THREE.ImageUtils.loadTexture( require('./cdp/amy2.jpg') );
    // var floorTexture1 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-1.jpg') );
    var floorTexture1 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f2 );
    floorTexture1.wrapS = floorTexture1.wrapT = THREE.RepeatWrapping;
    floorTexture1.repeat.set( 1, 1 );
    var floorMaterial1 = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture1, side:THREE.DoubleSide } );
    var floorGeometry1 = new THREE.PlaneGeometry(1000, 1000);
    floor1 = new THREE.Mesh(floorGeometry1, floorMaterial1);
    floor1.position.z = -500;
    floor1.rotation.z = -Math.PI / 2;
    floor1.visible = false
    box3dGroup.add(floor1);

    // ME
    // var floorTexture15 = new THREE.ImageUtils.loadTexture( require('./cdp/amy3.jpg') );
    // var floorTexture15 = new THREE.ImageUtils.loadTexture( require('./cdp/amy2.jpg') );
    // var floorTexture15 = new THREE.ImageUtils.loadTexture( require('./cdp2/lok.jpg') );
    // var floorTexture15 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
    var floorTexture15 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f3 );
    floorTexture15.wrapS = floorTexture15.wrapT = THREE.RepeatWrapping;
    floorTexture15.repeat.set( 1, 1 );
    var floorMaterial15 = new THREE.MeshBasicMaterial( { color: 0xfefcff, transparent: true, opacity: 1.0, map: floorTexture15, side:THREE.DoubleSide } );
    var floorGeometry15 = new THREE.PlaneGeometry(1000, 1000);
    floor15 = new THREE.Mesh(floorGeometry15, floorMaterial15);
    floor15.position.z = 500;
    floor15.rotation.z = -Math.PI / 2;
    floor15.visible = false
    box3dGroup.add(floor15);

    // Left
    // var floorTexture2 = new THREE.ImageUtils.loadTexture( require('./cdp2/waterdudv.jpg') );
    // var floorTexture2 = new THREE.ImageUtils.loadTexture( require('./cdp/waterdudv2.jpg') );
    // var floorTexture2 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-2.jpg') );
    // var floorTexture2 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
    var floorTexture2 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f4 );
    floorTexture2.wrapS = floorTexture2.wrapT = THREE.RepeatWrapping;
    floorTexture2.repeat.set( 1, 1 );
    var floorMaterial2 = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture2, side:THREE.DoubleSide } );
    var floorGeometry2 = new THREE.PlaneGeometry(1000, 1000);
    floor2 = new THREE.Mesh(floorGeometry2, floorMaterial2);
    floor2.position.x = -500;
    floor2.rotation.y = -Math.PI / 2;
    floor2.visible = false
    box3dGroup.add(floor2);

    // Left close
    // var floorTexture25 = new THREE.ImageUtils.loadTexture( require('./cdp2/sky-r1.jpg') );
    // var floorTexture25 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
    // var floorTexture25 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-2.jpg') );
    // var floorTexture25 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
    var floorTexture25 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f5 );
    floorTexture25.wrapS = floorTexture25.wrapT = THREE.RepeatWrapping;
    floorTexture25.repeat.set( 1, 1 );
    var floorMaterial25 = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture25, side:THREE.DoubleSide } );
    var floorGeometry25 = new THREE.PlaneGeometry(100, 100);
    floor25 = new THREE.Mesh(floorGeometry25, floorMaterial25);
    floor25.position.x = -100;
    floor25.rotation.y = -Math.PI / 2;
    floor25.visible = false
    box3dGroup.add(floor25);



    // Right
    // var floorTexture3 = new THREE.ImageUtils.loadTexture( require('./cdp2/sky-r1.jpg') );
    // var floorTexture3 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
    // var floorTexture3 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-2.jpg') );
    // var floorTexture3 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
    var floorTexture3 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f6 );
    floorTexture3.wrapS = floorTexture3.wrapT = THREE.RepeatWrapping;
    floorTexture3.repeat.set( 1, 1 );
    var floorMaterial3 = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture3, side:THREE.DoubleSide } );
    var floorGeometry3 = new THREE.PlaneGeometry(1000, 1000);
    floor3 = new THREE.Mesh(floorGeometry3, floorMaterial3);
    floor3.position.x = 500;
    floor3.rotation.y = -Math.PI / 2;
    floor3.visible = false
    box3dGroup.add(floor3);


    //7th
    var floorTexture = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f7 );
    floorTexture.wrapS = floorTexture.wrapT = THREE.RepeatWrapping;
    floorTexture.repeat.set( 1, 1 );
    var floorMaterial = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture, side:THREE.BackSide } );
    var floorGeometry = new THREE.PlaneGeometry(500, 500);
    var floor7 = new THREE.Mesh(floorGeometry, floorMaterial);
    floor7.position.y = -200;
    floor7.rotation.x = Math.PI / 2;
    floor7.visible = false
    box3dGroup.add(floor7);

    this.scene.add(box3dGroup);

    let cache = {}

    this.changeColor = ({ color1, color2, color3, color4, color5, color6, color7, texture, texture2, texture3, texture4, texture5, texture6, texture7 }) => {
      if(floor && cache.color1 !== color1) floor.material.color = new THREE.Color(color1);
      if(floor1 && cache.color2 !== color2) floor1.material.color = new THREE.Color(color2);
      if(floor15 && cache.color3 !== color3) floor15.material.color = new THREE.Color(color3);
      if(floor2 && cache.color4 !== color4) floor2.material.color = new THREE.Color(color4);
      if(floor25 && cache.color5 !== color5) floor25.material.color = new THREE.Color(color5);
      if(floor3 && cache.color6 !== color6) floor3.material.color = new THREE.Color(color6);

      if(texture && cache.texture !== texture) floor.material.map = new THREE.TextureLoader().load(texture)
      if(texture2 && cache.texture2 !== texture2) floor1.material.map = new THREE.TextureLoader().load(texture2)
      if(texture3 && cache.texture3 !== texture3) floor15.material.map = new THREE.TextureLoader().load(texture3)
      if(texture4 && cache.texture4 !== texture4) floor2.material.map = new THREE.TextureLoader().load(texture4)
      if(texture5 && cache.texture5 !== texture5) floor25.material.map = new THREE.TextureLoader().load(texture5)
      if(texture6 && cache.texture6 !== texture6) floor3.material.map = new THREE.TextureLoader().load(texture6)

      cache.texture = texture
      cache.texture2 = texture2
      cache.texture3 = texture3
      cache.texture4 = texture4
      cache.texture5 = texture5
      cache.texture6 = texture6
      cache.texture7 = texture7


      cache.color1 = color1
      cache.color2 = color2
      cache.color3 = color3
      cache.color4 = color4
      cache.color5 = color5
      cache.color6 = color6
      cache.color7 = color7
    }

    /* eslint-enable */

    // let cubeTextureStatic = new THREE.CubeTextureLoader().load(arr)
    // cubeTextureStatic.format = THREE.RGBFormat
    // cubeTextureStatic.needsUpdate = true
    let myKeyScene = new THREE.Scene()

    let cubeCamera = new THREE.CubeCamera(0.1, 10000, 512)
    this.scene.matrixAutoUpdate = false
    // this.scene.background = cubeTexture
    // cubeTexture.needsUpdate = true

    var objLoader = new THREE.OBJLoader()
    var keyObj = require('./keys/key1.obj')

    objLoader.load(keyObj, (object) => {
      let key = this.key = object.children[0]

      // this.scene.background = cubeTexture
      /*
        "mRefractionRatio": { type: "f", value: 0.988 },
        "mFresnelBias": { type: "f", value: 0.9 },
        "mFresnelPower": { type: "f", value: 2.0 },
        "mFresnelScale": { type: "f", value: 1.0 },
      */
      var uniforms = {
        // // shiny version
        // lok lok version
        // 'mRefractionRatio': { canChange: true, value: 1.02 },
        // 'mFresnelBias': { canChange: true, value: 0.1 },
        // 'mFresnelPower': { canChange: true, value: 3.0 },
        // 'mFresnelScale': { canChange: true, value: 1.2 },
        // 'colorMultiply': { value: new THREE.Color(0xffffff) },
        // 'colorAdd': { value: new THREE.Color(0x000000) },
        // 'colorSub': { value: new THREE.Color(0x000000) },

        // lok lok version 2
        // 'mRefractionRatio': { canChange: true, value: 1.02 },
        // 'mFresnelBias': { canChange: true, value: 0.1 },
        // 'mFresnelPower': { canChange: true, value: 3.0 },
        // 'mFresnelScale': { canChange: true, value: 1.2 },
        // 'colorMultiply': { value: new THREE.Color(0xffffff) },
        // 'colorAdd': { value: new THREE.Color(0x010024) },
        // 'colorSub': { value: new THREE.Color(0x000000) },

        // loklok & bianca version 3 1e2040
        // 'mRefractionRatio': { canChange: true, value: 0.0 },
        // 'mFresnelBias': { canChange: true, value: 0.2 },
        // 'mFresnelPower': { canChange: true, value: 0.0 },
        // 'mFresnelScale': { canChange: true, value: 0.3 },
        // 'colorMultiply': { value: new THREE.Color(0xffffff) },
        // 'colorAdd': { value: new THREE.Color(0x263250) },
        // 'colorSub': { value: new THREE.Color(0x000000) },

        //
        'mRefractionRatio': { canChange: true, value: 0.2 },
        'mFresnelBias': { canChange: true, value: 0.2 },
        'mFresnelPower': { canChange: true, value: 0.1 },
        'mFresnelScale': { canChange: true, value: 0.3 },
        'colorMultiply': { value: new THREE.Color(0xffffff) },
        'colorAdd': { value: new THREE.Color(0x263250) },
        'colorSub': { value: new THREE.Color(0x000000) },

        //
        // 'mRefractionRatio': { canChange: true, value: 0.7 },
        // 'mFresnelBias': { canChange: true, value: 0.2 },
        // 'mFresnelPower': { canChange: true, value: 0.1 },
        // 'mFresnelScale': { canChange: true, value: 0.3 },
        // 'colorMultiply': { value: new THREE.Color(0xffffff) },
        // 'colorAdd': { value: new THREE.Color(0x263250) },
        // 'colorSub': { value: new THREE.Color(0x000000) },

        // Bianca version 1
        // 'mRefractionRatio': { canChange: true, value: 1.5 },
        // 'mFresnelBias': { canChange: true, value: 0.7 },
        // 'mFresnelPower': { canChange: true, value: 2.0 },
        // 'mFresnelScale': { canChange: true, value: 1.0 },

        // 'colorMultiply': { value: new THREE.Color(0xffffff) },
        // 'colorAdd': { value: new THREE.Color(0x1e2040) },
        // 'colorSub': { value: new THREE.Color(0x000000) },

        // Bianca Version 2
        // 'mRefractionRatio': { canChange: true, value: 1.5 },
        // 'mFresnelBias': { canChange: true, value: 0.7 },
        // 'mFresnelPower': { canChange: true, value: 2.0 },
        // 'mFresnelScale': { canChange: true, value: 0.8 },

        // 'colorMultiply': { value: new THREE.Color(0xffffff) },
        // 'colorAdd': { value: new THREE.Color(0x14141e) },
        // 'colorSub': { value: new THREE.Color(0x000000) },

        'tCube': { value: null },
        'time': { value: 0 },
        'tDudv': { value: null },
        'viewVector': { value: new THREE.Vector3(0.0) },
        'useDudv': { value: true },
        'opacity': { canChange: true, value: 0.7 }
      }

      let tDudvTexture = new THREE.TextureLoader().load(require('./temp/diamond-1.jpg'))

      let uniforms2 = THREE.UniformsUtils.clone(uniforms)
      uniforms2['tCube'].value = cubeCamera.renderTarget.texture
      // uniforms2['tCube'].value = cubeTextureStatic // cubeCamera.renderTarget.texture
      uniforms2['tDudv'].value = tDudvTexture

      let material2 = new THREE.ShaderMaterial({
        transparent: true,
        uniforms: uniforms2,
        vertexShader: require('./WoozyShaders/SolidPerlin.vert'),
        fragmentShader: require('./WoozyShaders/SolidPerlinAddCon.frag'),
        // mapping: THREE.CubeRefractionMapping
        mapping: THREE.CubeRefractionMapping
        // mapping: THREE.CubeReflectionMapping
      })

      key.material = material2

      // -=-=-=-=-=GLOW=-=-=-=-=
      var glowMaterial = new THREE.ShaderMaterial({
        uniforms: {
          'c': {
            value: 6.0
          },
          'p': {
            value: 0.1
          },
          glowColor: {
            value: new THREE.Color(0xffffff)
          },
          viewVector: {
            value: this.camera.position.clone()
          },
          opacity: {
            value: 1.0
          }
        },
        vertexShader: require('./WoozyShaders/Glow.vert'),
        fragmentShader: require('./WoozyShaders/Glow.frag'),
        side: THREE.FrontSide,
        blending: THREE.AdditiveBlending,
        transparent: true
      })

      let moonGlow = new THREE.Mesh(key.geometry.clone(), glowMaterial.clone())
      moonGlow.position.x = key.position.x
      moonGlow.position.y = key.position.y
      moonGlow.position.z = key.position.z
      moonGlow.scale.x = 5.5
      moonGlow.scale.y = 5.5
      moonGlow.scale.z = 5.5
      this.glow = moonGlow
      // object.add(moonGlow)
      // -=-=-=-=-=

      let envBox = new THREE.Object3D()
      /* eslint-disable */
      let rtParameters = {
        minFilter: THREE.LinearFilter,
        magFilter: THREE.LinearFilter,
        format: THREE.RGBFormat,
        stencilBuffer: true
      }
      let dpi = window.devicePixelRatio || 1.0
      let composer = new THREE.EffectComposer(this.renderer, new THREE.WebGLRenderTarget( window.innerWidth, window.innerHeight, rtParameters ))
      composer.setSize(window.innerWidth * dpi, window.innerHeight * dpi);
      window.addEventListener('resize', () => {
        composer.setSize(window.innerWidth * dpi, window.innerHeight * dpi);
      }, false)

      let effectFXAA = new THREE.ShaderPass( THREE.FXAAShader );
      effectFXAA.uniforms[ 'resolution' ].value.set( 1 / window.innerWidth, 1 / window.innerHeight );
      effectFXAA.renderToScreen = true

      var effectCopy = new THREE.ShaderPass(THREE.CopyShader)
      effectCopy.renderToScreen = true

      let renderBG = new THREE.RenderPass(this.scene, this.camera)
      let renderModel = new THREE.RenderPass(myKeyScene, this.camera)

      var clearMask = new THREE.ClearMaskPass()
      var renderMask = new THREE.MaskPass(myKeyScene, this.camera)

      let bloomPass = new THREE.UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 ); //1.0, 9, 0.5, 512);
			// bloomPass.renderToScreen = true;

      bloomPass.threshold = Number(0.71)
      bloomPass.strength = Number(1.5)
      bloomPass.radius = Number(1.0)

      // composer.addPass( renderBG );
      // composer.addPass( renderMask );
      // composer.addPass( renderModel );
      // composer.addPass( clearMask );
      // composer.addPass( renderModel );
      // composer.addPass( bloomPass );

      /*
      composer4.addPass( renderScene );
      composer4.addPass( renderMask );
      composer4.addPass( effectDotScreen );
      composer4.addPass( clearMask );
      composer4.addPass( effectCopy );
      */

      composer.addPass( renderBG );
      // composer.addPass( renderMask );
      composer.addPass( bloomPass );
      // composer.addPass( clearMask );


      composer.addPass( effectCopy );

      myKeyScene.add(envBox)
      myKeyScene.add(object)

      /* eslint-enable */
      this.runrun = ({ wrapper, visible }) => {
        if (floor) floor.visible = this.RS.visible1
        if (floor1) floor1.visible = this.RS.visible2
        if (floor15) floor15.visible = this.RS.visible3
        if (floor2) floor2.visible = this.RS.visible4
        if (floor25) floor25.visible = this.RS.visible5
        if (floor3) floor3.visible = this.RS.visible6
        if (floor7) floor7.visible = this.RS.visible7

        if (key && key.material.uniforms) {
          key.material.uniforms.time.value = window.performance.now() / 1000
        }

        uniforms2['time'].value += 0.01

        uniforms2['viewVector'].value.x = key.position.x
        uniforms2['viewVector'].value.y = key.position.y
        uniforms2['viewVector'].value.z = key.position.z

        key.visible = false
        wrapper.scale.x = -1

        if (envBox) {
          envBox.visible = true
          envBox.visible = false
          envBox.rotation.z += 0.005
        }

        // this.cubeCamera.position.z = this.refractionBoxAlpha.parent.position.z
        cubeCamera.position.x = key.position.x
        cubeCamera.position.y = key.position.y
        cubeCamera.position.z = key.position.z

        moonGlow.rotation.copy(key.rotation)
        moonGlow.position.copy(key.position)
        // moonGlow.material.uniforms.viewVector.value.copy(key.position)

        cubeCamera.update(this.renderer, this.scene)
        wrapper.scale.x = 1
        // this.refractionBoxAlpha.visible = true
        key.visible = visible
        moonGlow.visible = visible

        if (envBox) {
          envBox.visible = this.viewBG
        }
        if (floor) floor.visible = this.RS.afterVisible1
        if (floor1) floor1.visible = this.RS.afterVisible2
        if (floor15) floor15.visible = this.RS.afterVisible3
        if (floor2) floor2.visible = this.RS.afterVisible4
        if (floor25) floor25.visible = this.RS.afterVisible5
        if (floor3) floor3.visible = this.RS.afterVisible6
        if (floor7) floor7.visible = this.RS.afterVisible7

        composer.render()
      }

      // uniforms['tCube'].value = cubeTexture
      // // uniforms['tCube'].value.mapping = THREE.CubeRefractionMapping
      // uniforms['tCube'].value.mapping = THREE.CubeReflectionMapping

      // let material3 = new THREE.ShaderMaterial({
      //   uniforms: uniforms,
      //   vertexShader: require('./WoozyShaders/Solid.vert'),
      //   fragmentShader: require('./WoozyShaders/Solid.frag')
      // })
      // key.material = material3
      // let material = key.material = new THREE.MeshBasicMaterial()
      // material.color = new THREE.Color(0xffffff)
      // material.refractionRatio = 0.98
      // material.reflectionRatio = 0.98
      // material.envMap = cubeTexture
      // material.envMap.mapping = THREE.CubeRefractionMapping
      // material.needsUpdate = true

      // key.geometry.computeFlatVertexNormals()
      key.geometry.computeBoundingSphere()
      key.geometry.computeBoundingBox()
      // key.material.shininess = true
      // key.material.transparent = true
      // key.material.opacity = 0.9
      // key.material.depthTest = false

      // object.position.z = -400

      key.scale.x = 5.0
      key.scale.y = 5.0
      key.scale.z = 5.0

      /* eslint-disable */
      var floorTexture2 = new THREE.ImageUtils.loadTexture( require('@/components/Parts/Key3D/temp/02.png') );
      // floorTexture2 = new THREE.ImageUtils.loadTexture( require('@/components/Parts/Key3D/temp/waterdudv2.jpg') );
      // floorTexture2.wrapS = floorTexture2.wrapT = THREE.RepeatWrapping;
      // floorTexture2.repeat.set( 1, 1 );
      var floorMaterial2 = new THREE.MeshBasicMaterial( { map: floorTexture2, color: 0xffffff } );

      this.remixFn = ({ texture }) => {
        floorMaterial2.map = new THREE.TextureLoader().load(texture)
        floorMaterial2.needsUpdate = true
      }
      this.remixBloom = ({ exposure, threshold, strength, radius }) => {
        bloomPass.exposure = Number(exposure)
        bloomPass.threshold = Number(threshold)
        bloomPass.strength = Number(strength)
        bloomPass.radius = Number(radius)
      }

      // let light = new THREE.PointLight(0xffffff, 50, 1000);
      // light.position.set( 0, 0, -450 );
      // envBox.add(light);

      var floorGeometry2 = new THREE.PlaneGeometry(1000, 1000);
      let floor2 = new THREE.Mesh(floorGeometry2, floorMaterial2);
      floor2.position.z = -500;
      // floor2.rotation.y = -Math.PI / 2;
      envBox.add(floor2);

      // var ambientLight = new THREE.AmbientLight(0x111111);
      // envBox.add(ambientLight);


      // let floor3 = new THREE.Mesh(floorGeometry2, floorMaterial2);
      // floor3.position.x = -500;
      // floor3.rotation.y = -Math.PI / 2;
      // envBox.add(floor3);

      // let floor4 = new THREE.Mesh(floorGeometry2, floorMaterial2);
      // floor4.position.x = 500;
      // floor4.rotation.y = -Math.PI / 2;
      // envBox.add(floor4);

      // let floor5 = new THREE.Mesh(floorGeometry2, floorMaterial2);
      // floor5.position.y = 500;
      // floor5.rotation.y = Math.PI / 2;
      // envBox.add(floor5);
      /* eslint-enabble */

      this.$emit('element', this)
      this.$parent.$emit('add', envBox)
      this.$parent.$emit('add', object)
      // this.$parent.$emit('add', light)
      this.clean = () => {
        this.$parent.$emit('remove', object)
        this.$parent.$emit('remove', envBox)

        // this.$parent.$emit('remove', light)
      }
    })
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Parts/Key3D/Key3D.vue